import { useEffect } from 'react';

import {
  useAppDispatch,
  useFlowState,
  useSeekerHKState,
  useSeekerState,
} from '@/components/AppState';
import useNextRoute from '@/components/hooks/useNextRoute';
import { logCareEvent } from '@/utilities/amplitudeAnalyticsHelper';
import { CARE_DATE_LABELS, FLOWS } from '@/constants';
import { isFromVhpWithZip, useVhpMfeSharedData } from '@/components/hooks/useVhpMfeSharedData';
import useEnterKey from '@/components/hooks/useEnterKey';
import CareDatePage from '../../care-date/CareDate';

function HousekeepingDatePage() {
  const { pushNextRoute } = useNextRoute();
  const { careDate } = useSeekerHKState();
  const dispatch = useAppDispatch();
  const { comeFrom } = useFlowState();
  const { zipcode, dataTransferMetadata } = useSeekerState();
  useVhpMfeSharedData();

  useEffect(() => {
    if (zipcode && isFromVhpWithZip(comeFrom, dataTransferMetadata)) {
      dispatch({ type: 'setFlowName', flowName: FLOWS.SEEKER_HOUSEKEEPING_FROM_VHP.name });
    }
  }, [zipcode, comeFrom]);

  const handleNext = () => {
    logCareEvent('Member Enrolled', 'Dates', {
      intent: CARE_DATE_LABELS[careDate],
    });
    pushNextRoute();
  };

  useEnterKey(true, () => handleNext(), true);

  return (
    <CareDatePage
      appAction="setHousekeepingDate"
      handleNext={handleNext}
      heading="When do you need a housekeeper?"
      selectedCareDate={careDate}
      selectorName="housekeepingDate"
    />
  );
}

export default HousekeepingDatePage;
